import script from "./FeedUrlView.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedUrlView.vue?vue&type=script&setup=true&lang=js"

import "./FeedUrlView.vue?vue&type=style&index=0&id=1671d72b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1671d72b"]])

export default __exports__